import classes from './BannerContentDulap.module.css'
import { CustomButton } from '~/components/CustomButton/CustomButton'
import { FormattedMessage } from 'react-intl'
import animationStyles from '~/styles/animations.module.css'

export const BannerContent = () => {
  return (
    <div className={classes.heroContent}>
      <div
        className={animationStyles.fadeInUp}
        style={{ animationDelay: '0.2s' }}
      >
        <h1 className={classes.visuallyHiddenHeader}>
          <FormattedMessage id="homepage.banner.header.hidden" />
        </h1>
        <h2 className={classes.heroHeader}>
          <FormattedMessage id="homepage.banner.header.0" />
        </h2>
      </div>
      <div
        className={animationStyles.fadeInUp}
        style={{ animationDelay: '0.4s' }}
      >
        <h2 className={classes.heroTitle}>
          <FormattedMessage id="homepage.banner.preorder.0" />
        </h2>
        <h2 className={classes.heroTitle}>
          <FormattedMessage id="homepage.banner.preorder.1" />
        </h2>
      </div>

      <div
        className={`${classes.heroButtonContainer} ${animationStyles.fadeInUp}`}
        style={{ animationDelay: '0.6s' }}
      >
        <CustomButton size="medium" variant="danger" href="/catalog">
          <FormattedMessage id="homepage.banner.cta" />
        </CustomButton>
      </div>
    </div>
  )
}
